import axios from 'axios'
import qs from 'qs'
import router from '../router'
import { Toast } from 'vant'
// 1. 生成Axios的伪实例, 能够使用Axios实例的属性，但不是Axios的实例
const instance = axios.create({
  baseURL: '/apis', // 设置请求的基本路径
  timeout: 10000, // 设置超时时间
})

// 2. 添加请求拦截器：1. 批量修改请求参数， 2. 批量添加请求参数
instance.interceptors.request.use(config => {
  // post请求参数默认为json对象形式： {a:xxx,b:yyy}, 但当前服务器识别urlcoding形式： a=xxx&b=yyy
//   if(config.method.toUpperCase() === 'POST' && (config.data instanceof Object)){
//     config.data = qs.stringify(config.data)
//   }

  return config;
})

//过滤
const fliters = function(res){
	if (res.code == 403) {
		ElMessageBox.alert('访问受限，请联系管理员',
			'提示', {
				confirmButtonText: '确定'
			})
	}
	if (res.code == 401 || res.code == 402) {
		ElMessageBox.alert('登录已过期请重新登录',
			'提示', {
				confirmButtonText: '确定',
				callback: res => {
					store.dispatch('resetToken').then(() => {
						location.reload()
					})
				}
			})
	}
	if (res.code == 500) {
		Toast({
			message: res.msg,
			type: 'error',
			duration: 3 * 1000
		})
	}
	if (res.code == 504) {
		Toast({
			message: '网络小波动，请稍后重试',
			type: 'error',
			duration: 3 * 1000
		})
	}
}

// 3. 设置响应拦截器

instance.interceptors.response.use(response => {
  fliters(response.data)
  if(response.data.code != 200){
    return Promise.reject(response.data)
  }
  return response.data
},
error => {
  try{
    fliters(error.response.data)
  }catch(e){
    fliters({code:504})
  }

  return Promise.reject(error)
})

export default instance
